import { deselectAll } from '../actions';
import { call, put, select } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client/pkg/request';
import { getGrusername } from '../selectors';
import { ALL_FOLDER_ID, SCRAPS_FOLDER_ID } from '@wix/da-url';
export default function*(action) {
    const { gallection, deviationIds, attribute, value } = action.payload;
    const { folderId } = gallection || {};
    const username = yield select(getGrusername);
    const params = {
        username,
        type: 'gallery',
        folderid: folderId && ![
            ALL_FOLDER_ID,
            SCRAPS_FOLDER_ID
        ].includes(folderId) ? folderId : undefined,
        all_folder: folderId === ALL_FOLDER_ID,
        scraps_folder: folderId === SCRAPS_FOLDER_ID,
        deviationids: deviationIds,
        attr_name: attribute,
        attr_value: value
    };
    yield call(requestPuppy, {
        method: 'post',
        url: 'gallection/folders/set_deviations_attr',
        data: params
    }, ()=>({
            success: true
        }));
    yield put(deselectAll());
}
